import QueryString from 'qs'

import { getRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { PaginatedResult } from '../../types/PaginatedResult'
import { SClassifiedSecretariat } from '../../types/api/Classified'
import { classifiedSecretariatTransformer } from '../../transformers/classifiedTransformer'

type GetClassifiedSecretariatsResponse = PaginatedResult<SClassifiedSecretariat>
export type getSecretariatsParams = {
  filters?: { [key: string]: any }
  populate?: { [key: string]: any }
  pagination?: {
    start?: number
    limit?: number
    page?: number
    pageSize?: number
    withCount?: boolean
  }
  sort?: string | Array<string>
}

const getSecretariats = (data: getSecretariatsParams) =>
  getRestRequest({
    url: `${api.REST_API_URL}/classified-secretariats?${QueryString.stringify(
      {
        ...data,
      },
      {
        encodeValuesOnly: true,
      }
    )}
    `,
    transformer: (response: GetClassifiedSecretariatsResponse) => {
      return response.data.map((secretariat) =>
        classifiedSecretariatTransformer(secretariat)
      )
    },
  })

export default getSecretariats
